import { Injectable } from '@angular/core';
import Auth from '@aws-amplify/auth';
import { Signer } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';

// npm packages
/**
 * npm i aws-amplify@4.2.9
 * npm i @aws-amplify/ui-angular
 * add in tsconfig.json -> "skipLibCheck": true,
 * init amplify on app.module.. see implementation in said file
 */

export interface SignedRequestParams {
  api_endpoint:string,
  api_path: string,
  http_method: string,
  aws_region: string,
  aws_service: string,
  data: any,
  params: any
}

@Injectable({
  providedIn: 'root'
})
export class AwsAmplifyAwsv4Service {

  constructor() { }

  generateSignedRequest(params:SignedRequestParams) {
    let request = {
      headers: {},
      url: null,
      params: null,
      data: null
    }

    return this.getEssentialCredentials().pipe(
      catchError(error => {
        if (!environment.production) {
          console.warn("Error getting credential", error)
        };
        return observableOf(null)
      }),
      switchMap((credentials: any) => {

        let queryString;

        // prepare creds
        const cred = {
          secret_key: credentials.secretAccessKey,
          access_key: credentials.accessKeyId,
          session_token: credentials.sessionToken
        }

        // setup which service and region
        const serviceInfo = {
          region: params.aws_region,
          service: params.aws_service
        }
  
        // prepare the request to sign
        const url = Location.joinWithSlash(params.api_endpoint, params.api_path);

        // if has params, we manually encode all params
        // note: before we use HttpParams of Angular, but it we get signature mismatch from AWSv4.
        // hence we now manually encode the params.
        if(params.params){
          queryString = Object.keys(params.params)
          .map(key=>`${key}=${encodeURIComponent(params.params[key])}`)
          .join('&');
        }

        let requestToSign: any = {
          headers: {},
          method: params.http_method,
          url: url.toString() + (params.params ? `?${queryString}` : ''),
        }
  
        if (params.data) {
          requestToSign.data = JSON.stringify(params.data)
        }
  
        // sign
        let signedRequest = Signer.sign(requestToSign, cred, serviceInfo)
        delete signedRequest.headers['host']
  
        // extract and return request
        request.headers = signedRequest.headers;
        request.url = url;
        request.params = params.params;

        if (params.data) {
          request.data = params.data;
        }
  
        return observableOf(request);
      })
    )
  }

  private getEssentialCredentials() {
    return from(Auth.currentCredentials()).pipe(
      map(creds => Auth.essentialCredentials(creds))
    )
  }
  
}
